import style from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/modals/AdminModalDeleteOA/AdminModalDeleteOA.module.scss';

import { Fade, Modal } from '@material-ui/core'
import { IState } from '@root-gipro/store/interfaces'
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Backdrop } from '@material-ui/core/'
import Loader from '@root-gipro/shared/Loader/Loader'
import { deleteProjectRPC, setProjectDeleteModalOA } from '@root-gipro/modules/userProjects/store/actions'

const ProjectModalDeleteOA: FC = () => {
	const {
		deleteOAModal
	} = useSelector((state: IState) => state.userProjects.rpc);
  
	const dispatch = useDispatch();

	const onCloseHandler = () => {
		dispatch(setProjectDeleteModalOA(null));
	};
	
	const onDeleteHandler = () => {
		if(deleteOAModal?.idObjectAnalog) {
			dispatch(deleteProjectRPC({
				idObjectAnalog: deleteOAModal.idObjectAnalog,
			}));
		}
	};

	return (
		<Modal
			open={deleteOAModal?.isOpen ?? false}
			onClose={onCloseHandler}
			aria-labelledby='simple-modal-title'
			aria-describedby='simple-modal-description'
			className={style.adminModalDeleteOA}
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 250,
			}}
		>
			<Fade in={deleteOAModal?.isOpen}>
				<div className={style.adminModalDeleteOA__content}>
					<h2 className={style.adminModalDeleteOA__title}>Удаление объекта-аналога</h2>

					<div className={style.adminModalDeleteOA__message}>Вы действительно хотите удалить этот объект-аналог?</div>

					<div className={style.adminModalDeleteOA__btns}>
						<button 
							className={[style.adminModalDeleteOA__btn, style.adminModalDeleteOA__btnDelete].join(' ')}
							onClick={onDeleteHandler}
						>
							Удалить
							<span
								className={
									style.adminModalDeleteOA__preloaderWr +
									(deleteOAModal.isDeleting ? ` ${style.adminModalDeleteOA__preloaderWrShow}` : '')
								}
							>
								<span className={style.adminModalDeleteOA__preloader}>
									<Loader />
								</span>
							</span>
						</button>

						<button 
              className={style.adminModalDeleteOA__btn}
              onClick={onCloseHandler}
            >
              Отмена
            </button>
					</div>
				</div>
			</Fade>
		</Modal>
	)
}

export default ProjectModalDeleteOA;
